import React, { Component } from 'react'
import './index.scss'

class CloseButton extends Component {
    render() {
        return (
            <div className='new-close-button-root-container'>
                <div className='line1' />
                <div className='line2' />
            </div>
        )
    }
}

export default CloseButton